import MasonryGrid from '../components/MasonryGrid';

export default class StaticCollectionsList {
  constructor(section) {
    this.el = section.el;
    this.masonry = this.el.querySelector('[data-masonry-grid]');
    this.masonryGrid = null;

    if (this.masonry) {
      this.masonryGrid = new MasonryGrid({ el: this.masonry });
    }
  }

  onSectionUnload() {
    if (this.masonryGrid) {
      this.masonryGrid.unload();
    }
  }
}
